export enum YouthInfoCenterTypeEnum {
  LOCALMISSION = 'mission_locale',
  CIJ = 'cij',
  APE = 'agency',
}
